import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Results from '../../components/Results';

import Pdf from '../../service/Pdf';

import styles from './styles.module.scss';

function Final({ state, setState, roomTypes, accessories }) {
  const { t } = useTranslation();

  const [sections, setSections] = useState([]);
  const [selectedAccessories, setSelectedAccessories] = useState(
    state.selectedAccessories
  );

  const pdf = new Pdf();
  const [generating, setGenerating] = useState(false);

  const downloadPdf = async () => {
    setGenerating(true);

    const pdfSections = sections.map((section) => section.key);

    pdf.setRooms(roomTypes);
    pdf.setSections(pdfSections);
    pdf.setAccessories(selectedAccessories);
    pdf.setTranslation(t);

    pdf
      .process()
      .then((output) => {
        pdf.save(t(`tool_ui.final.report_name`), output);
        setGenerating(false);
      })
      .catch((e) => {
        console.log('error', e);
        setGenerating(false);
      });

    setTimeout(() => {
      setGenerating(false);
    }, 500);

    // Adobe tracking
    window.lmd = window.globalLmd;
    window.lmd.download = t('tool_ui.button.save_pdf');
    window._satellite.track('Download');
  };

  const onBack = () => {
    setState({
      ...state,
      key: 'config',
      roomKey: roomTypes[0].key,
    });
  };

  const formatToString = (data) => {
    let string = '';

    Object.keys(data).forEach((key) => {
      const field = data[key];

      if (Array.isArray(field)) {
        string = string + key + ': ' + field.join(',') + '\n';
      } else {
        string = string + key + ': ' + field + '\n';
      }
    });
    return string;
  };

  const getInTouch = () => {
    const submitted = selectedAccessories.map((accessory) => {
      const roomName = roomTypes.find((room) => room.key === accessory.room);

      return { Option: t(accessory.name), Room: t(roomName.title) };
    });

    const results = submitted
      .map((accessory) => formatToString(accessory))
      .join('\n');

    window.parent.postMessage(
      {
        name: 'contact-rep',
        results: results,
      },
      '*'
    );

    // Adobe analytics
    window.lmd = window.globalLmd;
    window.lmd.formType = t('tool_ui.button.contact_rep');
    window._satellite.track('Form_Request');
  };

  useEffect(() => {
    const selectedRooms = roomTypes.filter((room) =>
      accessories[room.key].some((accessory) =>
        state.selectedAccessories.some(
          (selected) => selected.key === accessory.key
        )
      )
    );

    const updated = roomTypes.flatMap((room) => {
      const roomAccessories = accessories[room.key];

      return roomAccessories
        .filter((accessory) =>
          state.selectedAccessories.some(
            (selected) => accessory.key === selected.key
          )
        )
        .map((accessory) => ({
          ...state.selectedAccessories.find(
            (selected) => accessory.key === selected.key
          ),
          room: room.key,
        }));
    });

    setSelectedAccessories(updated);
    setSections(selectedRooms);
  }, [state, accessories, roomTypes]);

  return (
    <div className={styles.final}>
      <div className={`row ${styles.final__top}`}>
        <button className={styles.final__backButton} onClick={() => onBack()}>
          {t('tool_ui.button.back_to_rooms')}
        </button>
        <div className={styles.final__title}>
          <h2>{t('tool_ui.final.title')}</h2>
          <p>{t('tool_ui.final.text')}</p>
        </div>
        <div className={styles.final__ctas}>
          <button
            className={`${styles.final__cta} ${
              styles['final__cta--secondary']
            } ${generating ? styles['final__cta--loading'] : ''}`}
            onClick={downloadPdf}
            disabled={generating}
          >
            {generating ? 'Generating PDF' : t('tool_ui.button.save_pdf')}
          </button>
          <button
            className={`${styles.final__cta} ${styles['final__cta--primary']}`}
            onClick={getInTouch}
          >
            {t('tool_ui.button.contact_rep')}
          </button>
        </div>
      </div>

      <div className={`${styles.final__results} row`}>
        {sections &&
          sections.map((section, idx) => (
            <Results
              key={idx}
              section={section}
              selectedAccessories={selectedAccessories}
              t={t}
            />
          ))}
      </div>
    </div>
  );
}

export default Final;
